import { FieldErrors, UseFormRegister } from "react-hook-form";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import PasswordVisible from "../../../../components/Vectors/PasswordVisible";
import PasswordHide from "../../../../components/Vectors/PasswordHide";
import { LegalPersonInput } from "../../validation";
import { PasswordButtonsType } from "../LegalPerson";

interface PasswordInputProps {
  label: string;
  register: UseFormRegister<any>;
  errors: FieldErrors<LegalPersonInput>;
  passwordButtons: PasswordButtonsType;
  setPasswordButtons: React.Dispatch<React.SetStateAction<PasswordButtonsType>>;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  register,
  errors,
  passwordButtons,
  setPasswordButtons,
}) => {
  return (
    <TextField
      fullWidth
      {...register("password")}
      label={label}
      required
      error={!!errors.password}
      helperText={errors.password?.message}
      variant="standard"
      type={passwordButtons.showPassword ? "text" : "password"}
      inputProps={{
        style: {
          fontSize: 16,
          height: 30,
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Mostrar senha"
              onClick={() =>
                setPasswordButtons({
                  ...passwordButtons,
                  showPassword: !passwordButtons.showPassword,
                })
              }
            >
              {passwordButtons.showPassword ? (
                <PasswordVisible />
              ) : (
                <PasswordHide />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordInput;
